// ================= FIGHTER ART REGISTRY =================
//
// Every portrait/figure pair a deck can wear, keyed by ART KEY and grouped by the Style it is
// nominally of.
//
// WHY THIS EXISTS SEPARATELY FROM DECK_META. The deck builder's art picker was
// `Object.keys(window.DECK_META)`, which worked only because the fifteen art basenames happened to
// BE the fifteen deck ids. That coincidence made three things impossible:
//
//   - Art that is not a deck's. There was nowhere to put it, and `figureFor` resolved a figure by
//     looking up DECK_META, so an art key with no deck behind it returned null and the card tiles
//     rendered figureless WITHOUT erroring.
//   - Art for a Style with no deck yet. Adding a ninth Style meant shipping a deck before its
//     fighters could exist.
//   - Renaming. Since phase 3 the picker's keys are also written into saved decks and, since phase
//     4, into share codes, so they are a wire format now whether or not anyone intended that.
//
// AN ART KEY IS PERMANENT. It appears in `sc.customDecks.v1` records and inside every SCD1 share
// code, so renaming one silently re-points other people's decks at different art. The fifteen below
// keep the deck ids they have always had, which is what makes every deck saved before this file
// existed still resolve. Add keys; do not rename or remove them. If art is retired, leave the entry
// and point it at a replacement image rather than deleting the key.
//
// ADDING ART is a data edit here and nothing else: the builder groups the picker by `style` and
// discovers new entries automatically, `figureFor` resolves them, and the store writes their paths
// into DECK_META for merged custom decks. tests/fighter-art-test.js checks that every file named
// here exists on disk and that the fifteen deck-backed entries still agree with DECK_META.
//
// ADDING A STYLE later needs no change to this file's shape: give the new art entries the new Style
// key. The builder renders a group per Style in window.STYLES order and then any remaining Styles
// it finds here, so art can land before or after the Style itself does.
window.FIGHTER_ART = {
  outside_reader: {
    label: "The Outside Reader", style: "WesternBoxing",
    portrait: "assets/portraits/outside_reader.webp",
    rangeFigure: "assets/figures/outside_reader.png"
  },
  back_alley_infighter: {
    label: "The Back-Alley Infighter", style: "WesternBoxing",
    portrait: "assets/portraits/back_alley_infighter.webp",
    rangeFigure: "assets/figures/back_alley_infighter.png"
  },
  shovel_trap: {
    label: "The Shovel Trap", style: "WesternBoxing",
    portrait: "assets/portraits/shovel_trap.webp",
    rangeFigure: "assets/figures/shovel_trap.png"
  },
  distance_tax: {
    label: "Eight-Limb Distance Tax", style: "MuayThai",
    portrait: "assets/portraits/distance_tax.webp",
    rangeFigure: "assets/figures/distance_tax.png"
  },
  clinch_furnace: {
    label: "The Clinch Furnace", style: "MuayThai",
    portrait: "assets/portraits/clinch_furnace.webp",
    rangeFigure: "assets/figures/clinch_furnace.png"
  },
  rooted_powerline: {
    label: "Rooted Powerline", style: "ShotokanKarate",
    portrait: "assets/portraits/rooted_powerline.webp",
    rangeFigure: "assets/figures/rooted_powerline.png"
  },
  ghost_step: {
    label: "Ghost Step Arsenal", style: "Taekwondo",
    portrait: "assets/portraits/ghost_step.webp",
    rangeFigure: "assets/figures/ghost_step.png"
  },
  skyfire_exhibition: {
    label: "Skyfire Exhibition", style: "Taekwondo",
    portrait: "assets/portraits/skyfire_exhibition.webp",
    rangeFigure: "assets/figures/skyfire_exhibition.png"
  },
  centerline_rewoven: {
    label: "The Centerline Loom", style: "WingChun",
    portrait: "assets/portraits/centerline_rewoven.webp",
    rangeFigure: "assets/figures/centerline_rewoven.png"
  },
  angle_thief: {
    label: "The Angle Thief", style: "PencakSilat",
    portrait: "assets/portraits/angle_thief.webp",
    rangeFigure: "assets/figures/angle_thief.png"
  },
  chain_reaction: {
    label: "Chain Reaction", style: "Wrestling",
    portrait: "assets/portraits/chain_reaction.webp",
    rangeFigure: "assets/figures/chain_reaction.png"
  },
  lowline_algorithm: {
    label: "Lowline Algorithm", style: "Wrestling",
    portrait: "assets/portraits/lowline_algorithm.webp",
    rangeFigure: "assets/figures/lowline_algorithm.png"
  },
  opportunists_knot: {
    label: "The Opportunist's Knot", style: "Judo",
    portrait: "assets/portraits/opportunists_knot.webp",
    rangeFigure: "assets/figures/opportunists_knot.png"
  },
  grand_ippon: {
    label: "The Grand Ippon", style: "Judo",
    portrait: "assets/portraits/grand_ippon.webp",
    rangeFigure: "assets/figures/grand_ippon.png"
  }
};

// Art keys grouped for a picker: every Style in window.STYLES order first, then any Style this file
// names that the game does not have yet (art can land before the Style it belongs to). `first` puts
// one Style at the top, which is how the builder shows the deck's own Style before the rest.
//
// -> [{ style, label, keys: [artKey] }]
window.fighterArtGroups = function (first) {
  var art = window.FIGHTER_ART, byStyle = {}, order = [];
  Object.keys(art).forEach(function (key) {
    var s = art[key].style || 'Other';
    if (!byStyle[s]) { byStyle[s] = []; }
    byStyle[s].push(key);
  });
  (window.STYLES || []).forEach(function (s) { if (byStyle[s]) order.push(s); });
  Object.keys(byStyle).sort().forEach(function (s) { if (order.indexOf(s) < 0) order.push(s); });
  if (first && byStyle[first]) order = [first].concat(order.filter(function (s) { return s !== first; }));
  return order.map(function (s) {
    return {
      style: s,
      label: (window.STYLE_LABELS && window.STYLE_LABELS[s]) || s,
      keys: byStyle[s].slice()
    };
  });
};
